import { useTranslation } from "react-i18next";
import { NaviButtons } from "../components/NaviButtons";

export const StepIdentification = ({
	returnUrl,
	identity,
	onBack
}: {
	returnUrl: string;
	identity: () => void;
	onBack: () => void;
}) => {
	const { t } = useTranslation();

	return (
		<div className="row">
			<div className="col-md-12 col-sm-12 col-xs-12">
				<h3>{t("identificationTitle")}</h3>
				<p>{t("companyCheckSuccess")}</p>
				<NaviButtons
					backVisible
					onBack={onBack}
					cancelVisible
					onCancel={() => (window.location.href = returnUrl)}
					nextText="identify"
					onNext={identity}
				/>
			</div>
		</div>
	);
};
